'use strict';

angular.module('app')
    .service('EpsonPrinterService', ['$locale', '$q', '$translate', 'PrinterService', function ($locale, $q, $translate, PrinterService) {
        var tmpBuilder = new epson.ePOSBuilder();

        this.CutTypes = {
            FEED: tmpBuilder.CUT_FEED,
            RESERVE: tmpBuilder.CUT_RESERVE,
            NO_FEED: tmpBuilder.CUT_NO_FEED
        };

        this.Alignments = {
            LEFT: tmpBuilder.ALIGN_LEFT,
            CENTER: tmpBuilder.ALIGN_CENTER,
            RIGHT: tmpBuilder.ALIGN_RIGHT
        };

        var deferred;

        this.initializePrintRequest = function (printerIpAddress, printerDeviceId) {
            var printAddress = PrinterService.getPrintRequestAddress(printerIpAddress);
            var fullUrl = printAddress + '/cgi-bin/epos/service.cgi?devid=' + printerDeviceId + '&timeout=10000';
            this.builder = new epson.ePOSBuilder();
            this.epos = new epson.ePOSPrint(fullUrl);
            this.epos.timeout = 10000;
            this.epos.onreceive = this.onReceive.bind(this);
            this.epos.onerror = function () {
                deferred.reject($translate.instant('recipeViewer.print.errorMsg.configError'));
            };
        };

        this.sendMessage = function () {
            this.epos.send(this.builder.toString());
        };

        this.feed = function (line, unit) {
            if (line) {
                this.builder.addFeedLine(line);
                //unit is in dots
            } else if (unit) {
                this.builder.addFeedUnit(unit);

            } else {
                this.builder.addFeed();
            }
        };

        this.cutPaper = function (type) {
            this.builder.addCut(type);
        };

        this.align = function (position) {
            this.builder.addTextAlign(position);
        };

        this.smooth = function () {
            this.builder.addTextSmooth(true);
        };

        this.doubleSize = function (width, height) {
            this.builder.addTextDouble(width, height);
        };

        this.addText = function (data) {
            this.builder.addText(data);
        };

        this.addTextLine = function (data) {
            this.addText(data + '\n');
        };

        this.addTextStyle = function (reverse, underline, bold, color) {
            this.builder.addTextStyle(reverse, underline, bold, color);
        };

        this.boldText = function (bold) {
            this.builder.addTextStyle(false, false, bold, this.builder.COLOR_1);
        };

        this.onReceive = function (response) {
            if (response.success) {
                deferred.resolve('SUCCESS');
            } else {
                if (response.code === 'EPTR_COVER_OPEN') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.printerCoverClosed'));
                } else if (response.code === 'EPTR_BATTERY_LOW') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.printerBatteryDown'));
                } else if (response.code === 'EPTR_CUTTER') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.ensurePrinterAutoCutter'));
                } else if (response.code === 'EPTR_MECHANICAL') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.mechanicalError'));
                } else if (response.code === 'EPTR_REC_EMPTY') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.missingEnoughPaper'));
                } else if (response.code === 'DeviceNotFound') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.invalidDeviceId'));
                } else {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.unknownError'));
                }
            }
        };

        this.printRecipeWithPrintHistory = function (recipePrintHistory, recipeName) {
            deferred = $q.defer();
            this.printRecipe(recipePrintHistory.printerConfig.printerIpAddress, recipePrintHistory.printerConfig.printerDeviceId, recipePrintHistory.prepChef,
                recipePrintHistory.batchNumber, recipePrintHistory.prepDate, recipePrintHistory.expireDate,
                recipePrintHistory.notes, recipePrintHistory.quantity, recipeName);
            return deferred.promise;
        };

        this.printTimestamp = function (printerConfig, prepChef, date, name, quantity) {
            deferred = $q.defer();
            this.initializePrintRequest(printerConfig.printerIpAddress, printerConfig.printerDeviceId);
            this.align(this.Alignments.CENTER);
            this.smooth();
            
            var chefPrefix = $translate.instant('recipeViewer.print.prefix.chef');
            var recipeNamePrefix = $translate.instant('recipeViewer.print.prefix.recipeName');
            var datePrefix = $translate.instant('recipeViewer.print.prefix.date');
            
            for (var i = 0; i < quantity; i++) {
                if (i > 0) {
                    //add an empty line because timestamp labels can be really small
                    this.addTextLine('');
                }
                    
                if (prepChef) {
                    this.addTextLine(chefPrefix + prepChef);
                }
                if (name) {
                    this.addTextLine(recipeNamePrefix + name);
                }
                this.boldText(true);
                this.addTextLine(datePrefix + PrinterService.getDateStr(date));
                this.feed();
                this.cutPaper(this.CutTypes.FEED);
            }
            this.sendMessage();
            return deferred.promise;
        };

        this.printRecipe = function (printerIpAddress, printerDeviceId, prepChef, batchNumber, prepDate, expireDate, notes, quantity, recipeName) {
            var expireDayOfWeek = expireDate ? $locale.DATETIME_FORMATS.DAY[expireDate.getDay()] : null;
            this.initializePrintRequest(printerIpAddress, printerDeviceId);
            
            var prepChefPrefix = $translate.instant('recipeViewer.print.prefix.prepChef');
            var batchNumberPrefix = $translate.instant('recipeViewer.print.prefix.batchNumber');
            var prepDayPrefix = $translate.instant('recipeViewer.print.prefix.prepDay');
            var expiresPrefix = $translate.instant('recipeViewer.print.prefix.expires');
            var notesPrefix = $translate.instant('recipeViewer.print.prefix.notes');
            
            for (var i = 0; i < quantity; i++) {
                this.align(this.Alignments.CENTER);
                this.smooth();
                this.boldText(true);
                this.doubleSize(true, true);
                this.addTextLine(recipeName);
                this.boldText(false);
                this.doubleSize(false, false);
                this.addTextLine(prepChefPrefix + prepChef);
                this.addTextLine(batchNumberPrefix + batchNumber);
                this.addTextLine(prepDayPrefix + PrinterService.getDateStr(prepDate));
                if (expireDate) {
                    this.addTextLine(expiresPrefix + PrinterService.getDateStr(expireDate));
                }
                if (notes) {
                    this.addTextLine(notesPrefix + notes);
                }
                if (expireDate) {
                    this.boldText(true);
                    this.doubleSize(true, true);
                    this.addTextLine(expireDayOfWeek.toUpperCase());
                }
                this.cutPaper(this.CutTypes.FEED);
            }
            this.sendMessage();
        };
    }]);